<div class="bottom-bar-container">
  <ng-container *ngFor="let actionButton of actionButtons">
    <button
      class="bottom-bar-button focus-link"
      (click)="actionButton.clickEvent()">
      <rd-shared-icon
        class="icon"
        [iconSymbol]="iconize(actionButton.icon)"></rd-shared-icon>
      <div class="action-button-text-wrapper">
        <span class="indicator-on" *ngIf="!!actionButton.indicatorOn"></span>
        <span class="action-button-text">{{ actionButton.text }}</span>
      </div>
    </button>
    <div class="button-divider"></div>
  </ng-container>
</div>
